import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { AuthRequest, AuthResponse, AuthValidation } from '@/models';

import { API_AUTH_URL, API_BUSINESS_URL } from '@/utils';

const authService = createApi({
  reducerPath: 'authService',
  baseQuery: fetchBaseQuery({ baseUrl: `${API_AUTH_URL}` }),
  endpoints: (builder) => ({
    login: builder.mutation<AuthResponse, AuthRequest>({
      query: (credentials) => ({
        url: `${API_BUSINESS_URL}/auth/login/web`,
        method: 'POST',
        body: credentials,
      }),
    }),
    validate: builder.query<AuthValidation, { accessToken: string }>({
      query: ({ accessToken }) => ({
        url: '/user/validate',
        method: 'POST',
        headers: {
          access_token: accessToken,
        },
      }),
    }),
    logout: builder.mutation<void, { refreshToken: string }>({
      query: ({ refreshToken }) => ({
        url: '/user/logout',
        method: 'POST',
        headers: {
          refresh_token: refreshToken,
        },
      }),
    }),
  }),
});

export default authService;

export const {
  useLoginMutation,
  useValidateQuery,
  useLogoutMutation,
} = authService;
